<template>
	<gc-dialog
		title="取消任务"
		:show.sync="visible"
		@close="$emit('close-modal')"
		@cancel="$emit('close-modal')"
		@ok="handleSubmitForm"
		width="460px"
	>
		<el-form :model="modelForm" :rules="rules" ref="modelForm" label-position="top" label-width="100px">
			<el-form-item label="取消原因" prop="remark">
				<el-input
					size="small"
					v-model="modelForm.remark"
					type="textarea"
					:rows="3"
					resize="none"
					placeholder="请输入"
				></el-input>
			</el-form-item>
		</el-form>
	</gc-dialog>
</template>

<script>
import { ruleRequired, ruleMaxLength } from '@/utils/rules'
import { apiCancelDeviceImeiRegistTask } from '@/apis/communicationModelManage.api'
export default {
	name: 'BatchImportCancelTaskModal',
	props: {
		taskId: String,
	},
	data() {
		return {
			visible: true,
			modelForm: {
				remark: null,
			},
			rules: {
				remark: [ruleRequired(), ruleMaxLength(200)],
			},
		}
	},

	methods: {
		handleSubmitForm() {
			this.$refs.modelForm.validate(async valid => {
				if (valid) {
					const searchParams = {
						...this.modelForm,
						taskId: this.taskId,
						manufacturerId: this.manufacturerId,
					}
					await apiCancelDeviceImeiRegistTask(searchParams)
					this.$message.success('取消任务成功')
					this.$emit('close-modal', true)
				}
			})
		},
	},

	computed: {
		manufacturerId() {
			return this.$store.getters.userInfo.manufacturerId
		},
	},
}
</script>
